var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53501 15.8358H12.465C12.3665 16.4183 12.0649 16.9471 11.6137 17.3284C11.1625 17.7098 10.5908 17.919 10 17.919C9.40924 17.919 8.83756 17.7098 8.38634 17.3284C7.93512 16.9471 7.63351 16.4183 7.53501 15.8358V15.8358ZM10 1.66916C11.6576 1.66916 13.2473 2.32764 14.4194 3.49974C15.5915 4.67184 16.25 6.26156 16.25 7.91916V11.2525L17.4317 13.8858C17.4854 14.0063 17.5082 14.1382 17.498 14.2697C17.4877 14.4012 17.4448 14.528 17.3731 14.6387C17.3014 14.7494 17.2032 14.8404 17.0874 14.9035C16.9716 14.9666 16.8419 14.9998 16.71 15H3.29334C3.16128 15 3.03133 14.9669 2.91531 14.9038C2.79929 14.8408 2.7009 14.7497 2.62909 14.6388C2.55728 14.528 2.51433 14.401 2.50415 14.2693C2.49398 14.1377 2.5169 14.0055 2.57084 13.885L3.75001 11.2517V7.90833L3.75417 7.69999C3.81118 6.08154 4.49417 4.54839 5.65925 3.42357C6.82434 2.29874 8.38055 1.67007 10 1.66999V1.66916Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 4,
    r: 3,
    fill: "#AD0606"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSolid);
export default __webpack_public_path__ + "static/media/bell-solid.d020eb839611e35411586c489d7414e6.svg";
export { ForwardRef as ReactComponent };